import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {ProductContainerSearchModel} from "../product-container-search.model";
import {
    ProductContainerSearchPageComponent
} from "../product-container-search-page/product-container-search-page.component";
import {ProductContainerEditPageComponent} from "../product-container-edit-page/product-container-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-product-container-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(ProductContainerSingleSelectEditControlComponent),
        provideSearchModel(ProductContainerSearchModel)
    ]
})
export class ProductContainerSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<ProductContainerSearchModel> {
    constructor(model: ProductContainerSearchModel, injector: Injector) {
        super(model, injector, "containerId", "name");

        this.extendedSearchComponent = ProductContainerSearchPageComponent;
        this.extendedEditComponent = ProductContainerEditPageComponent;
    }
}
